(function () {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    trackPageScroll();
    trackAtcClicks();
    trackCheckoutClicks();
    trackUsersInCart();
  }

  function trackPageScroll() {
    const thresholds = [25, 50, 75, 100];
    const sentThresholdGoals = [];
    const debouncedScrollHandler = debounce(handleGoal, 20);

    handleGoal();
    window.addEventListener("scroll", debouncedScrollHandler);

    function handleGoal() {
      const pageHeight = document.body.scrollHeight - window.innerHeight - 2;
      const currentScroll = window.scrollY;
      const scrollPercent = Math.ceil((currentScroll / pageHeight) * 100);

      thresholds.forEach((threshold) => {
        if (
          !sentThresholdGoals.includes(threshold) &&
          scrollPercent > threshold
        ) {
          _mktz.push(["_Goal", `s-scroll-past-${threshold}`]);
          sentThresholdGoals.push(threshold);
        }
      });

      // Remove event listener when all scroll goals are sent
      if (sentThresholdGoals.length === thresholds.length) {
        window.removeEventListener("scroll", debouncedScrollHandler);
      }
    }

    function debounce(func, delay) {
      let timerId = "";

      return function (...args) {
        clearTimeout(timerId);

        timerId = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    }
  }

  function trackAtcClicks() {
    const atcButtons = document.querySelectorAll(
      "#AddToCart-button, #AddToCart-2"
    );
    if (atcButtons) {
      atcButtons.forEach((x) => {
        x.addEventListener("click", function () {
          _mktz.push(["_Goal", "add-to-cart-clicks"]);
        });
      });
    }
  }

  function trackCheckoutClicks() {
    const buttons = document.querySelectorAll("#cart-initiateCheckout");
    buttons.forEach((x) => {
      x.addEventListener("click", function () {
        _mktz.push(['_Goal', 'checkout-clicks']);
      });
    });
  }

  function trackUsersInCart() {
    if (location.pathname == "/cart") {
      _mktz.push(['_Goal', 'users-in-cart', 1]);
    }
  }
})();
